const navbarToggler = document.querySelector('.navbar-toggler');
const navbarCollapse = document.querySelector('.navbar-collapse');

navbarCollapse.addEventListener('show.bs.collapse', function () {
  navbarToggler.classList.add('collapsed-x');
});

navbarCollapse.addEventListener('hide.bs.collapse', function () {
  navbarToggler.classList.remove('collapsed-x');
});

document.addEventListener('DOMContentLoaded', function() {
    // Bootstrap's 'lg' breakpoint
    const mobileBreakpoint = 992;
    const menuContainer = document.getElementById('main-menu');
    const openClass = 'mobile-dropdown-open'; // For double-tap logic

    function setupMobileDropdowns() {
        // Only apply logic if the viewport is mobile-sized
        if (window.innerWidth < mobileBreakpoint) {

            // Selector for the links that lead to the third tier (e.g., "Home Care")
            let nestedDropdownLinks = menuContainer.querySelectorAll('.dropdown-menu > .menu-item-has-children > a');

            nestedDropdownLinks.forEach(function(link) {
                // Remove existing listener to prevent stacking on resize
                link.removeEventListener('click', mobileToggleHandler);
                link.addEventListener('click', mobileToggleHandler);
            });
        }
    }

    function mobileToggleHandler(e) {
        // Exit if not in mobile view
        if (window.innerWidth >= mobileBreakpoint) {
            return;
        }

        const parentLi = e.currentTarget.closest('.menu-item-has-children');
        const subMenu = e.currentTarget.nextElementSibling;

        // Check for the sub-menu element
        if (!subMenu || !subMenu.classList.contains('dropdown-menu')) {
            return;
        }

        // 1. First click: Prevent navigation and toggle menu open
        if (!parentLi.classList.contains(openClass)) {
            e.preventDefault();
            e.stopPropagation();

            // Close all sibling menus 
            parentLi.parentElement.querySelectorAll('.menu-item-has-children').forEach(function(li) {
                if (li !== parentLi) {
                    li.classList.remove(openClass);
                    li.querySelector('.dropdown-menu').classList.remove('show-mobile-dropdown');
                }
            });

            // Open the current menu
            parentLi.classList.add(openClass);
            // ADD the CSS class that uses display: block !important
            subMenu.classList.add('show-mobile-dropdown'); 
        } 
        // 2. Second click: Allow default link action (navigation)
        else {
            // Remove the classes, allowing navigation to proceed
            parentLi.classList.remove(openClass);
            subMenu.classList.remove('show-mobile-dropdown');
        }
    }

    // Run on load and on resize
    window.addEventListener('resize', setupMobileDropdowns);
    setupMobileDropdowns(); 
});